module.exports = __webpack_public_path__ + "img/device.e21fb2c2.png";